import React, { useState, useEffect } from 'react';

import AgreementFormPrint from './AgreementFormPrint';
import { Grid } from '@material-ui/core';
import { PrimaryButton } from 'Components/Inputes/CustomButton';
const AgreementForm = () => {
    const [isAlertOpen, setIsAlertOpen] = useState(false);

    const Print = () => {
        setIsAlertOpen(true);
    };
    useEffect(() => {
        setIsAlertOpen(true);
    }, []);
    return (
        <div>
            <Grid
                container
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ marginTop: '15px' }}
            >
                <Grid xs={12} sm={12} md={2} lg={2}>
                    {
                        <PrimaryButton
                            variant="contained"
                            color="primary"
                            title="Print"
                            onClick={() => Print()}
                        >
                            Print
                        </PrimaryButton>
                    }
                    {isAlertOpen ? (
                        <AgreementFormPrint
                            isOpen={isAlertOpen}
                            title="Agreement Form"
                            positiveButtonClick={(printData) => {
                                setIsAlertOpen(false);
                            }}
                            negativeButtonClick={() => {
                                setIsAlertOpen(false);
                            }}
                        />
                    ) : null}
                </Grid>
            </Grid>
        </div>
    );
};
export default AgreementForm;
